module.exports = __webpack_public_path__ + "media/images/web/landings/students/s7-4c19aad7fcf61626c85c9cff2904f1b9.jpg";